import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import React from 'react';
import Button from "../../Common/FooterButton";
import { Keys, Routes } from "../../Common/Constants";
import { isCountryFieldValid, isDegreeFieldValid, isEducationLevelFieldValid, isEducationStatusFieldValid } from "../../Utilities/Validators";
import { askForStandardizedTests } from "../../Utilities/Helper";
import { CefEvent, CefEventName, Platform, Reason } from "../../../../EventTracker";
import useCefNavigation from "../../Hooks/useCefNavigation";
import { useCefEventTracker } from "../../Hooks/useCefEventTracker";
export var FooterButton = function FooterButton(_ref) {
  var countriesData = _ref.countriesData,
    degree = _ref.degree,
    educationCountry = _ref.educationCountry,
    educationLevel = _ref.educationLevel,
    educationStatus = _ref.educationStatus,
    families = _ref.families,
    levels = _ref.levels,
    setField = _ref.setField,
    setDegreeErrorMessage = _ref.setDegreeErrorMessage,
    setEducationCountryErrorMessage = _ref.setEducationCountryErrorMessage,
    setEducationLevelErrorMessage = _ref.setEducationLevelErrorMessage,
    setEducationStatusErrorMessage = _ref.setEducationStatusErrorMessage;
  var navigate = useCefNavigation();
  var _useCefEventTracker = useCefEventTracker(),
    trackEvent = _useCefEventTracker.trackEvent;
  var onClick = function onClick() {
    var invalidFields = [];
    var countryValidationData = isCountryFieldValid(educationCountry === null || educationCountry === void 0 ? void 0 : educationCountry.name, countriesData, Keys.Application.educationCountry);
    var educationLevelValidationData = isEducationLevelFieldValid(educationLevel, families);
    var degreeValidationData = isDegreeFieldValid(degree, educationLevel, levels);
    var educationStatusValidationData = isEducationStatusFieldValid(educationStatus);
    if (!educationStatusValidationData[0]) {
      setEducationStatusErrorMessage(educationStatusValidationData[1]);
      invalidFields.push(Keys.Application.educationStatus);
    }
    if (!countryValidationData[0]) {
      setEducationCountryErrorMessage(countryValidationData[1]);
      invalidFields.push(Keys.Application.educationCountry);
    }
    if (!educationLevelValidationData[0]) {
      setEducationLevelErrorMessage(educationLevelValidationData[1]);
      invalidFields.push(Keys.Application.educationLevel);
    }
    if (educationLevel && !degreeValidationData[0]) {
      setDegreeErrorMessage(degreeValidationData[1]);
      invalidFields.push(Keys.Application.degree);
    }
    if (countryValidationData[0] && educationLevelValidationData[0] && degreeValidationData[0] && educationStatusValidationData[0]) {
      if (!askForStandardizedTests(degree)) {
        setField({
          key: Keys.Application.standardizedTests,
          value: {
            gmat: false,
            gre: false,
            dont_have: true
          }
        });
      } else {
        setField({
          key: Keys.Application.standardizedTests,
          value: {
            gmat: false,
            gre: false,
            dont_have: false
          }
        });
      }
      navigate(Routes.Eligibility.OverallGradeQuestion);
    } else {
      trackEvent(CefEvent(CefEventName.FailedToNavigateToNextStep, Platform.Mobile, {
        incomplete_fields: invalidFields.join(', '),
        reason: Reason.EmptyField
      }));
    }
  };
  return /*#__PURE__*/React.createElement(Button, {
    label: "Next",
    onClick: onClick
  });
};